import 'css-chunksrc/client/pages/listPage/details/styles.scss';export default {
  "details": "_details_1n8g3_1",
  "name": "_name_1n8g3_5",
  "input": "_input_1n8g3_15",
  "description": "_description_1n8g3_25",
  "label": "_label_1n8g3_29",
  "paragraph": "_paragraph_1n8g3_35",
  "advancement": "_advancement_1n8g3_45",
  "percentage": "_percentage_1n8g3_52",
  "progressBar": "_progressBar_1n8g3_61",
  "advancementLabel": "_advancementLabel_1n8g3_66",
  "descriptionMaxChars": "_descriptionMaxChars_1n8g3_73",
  "loader": "_loader_1n8g3_78",
  "loaderMain": "_loaderMain_1n8g3_86"
};